/**
 * 多语言
 * 1.本地调试时使用
 */

import Vue from "vue";
import VueI18n from "vue-i18n";

// 引入需要语言包也可是js文件，export default抛出语言包的对象
import en from './en-US.json'
import zh from'./zh-CN.json'

Vue.use(VueI18n);

const language = sessionStorage.getItem("language") || (navigator.language || navigator.browserLanguage) || window.dockerConfig.defaultLang || "zh-CN";

const i18n = new VueI18n({
    locale: language,
    messages: {
      "en-US": Object.assign({}, en),
      "zh-CN": Object.assign({}, zh)
    }
});

export default i18n;